module.exports = __webpack_public_path__ + "img/hide.ff84b853.svg";